import { Result } from '@/types/slide';
import { gql } from '@apollo/client';

export interface GetClassroomResponse {
    testroom: {
        id: string;
        testroomName: string;
        lessonVersion: {
            id: string;
            slides: {
                id: string;
                sort: number;
                data: string;
            }[];
        };
        class: {
            name: string;
            schoolYear: string;
            studentsCount: number;
            students: {
                id: string;
                familyName: string;
                givenName: string;
                studentNumber: string;
            }[];
        };
    };
}

export interface GetClassroomVariables {
    where: {
        id: string;
    };
}

export const GET_CLASSROOM = gql`
    query Testroom($where: TestroomWhereUniqueInput!) {
        testroom(where: $where) {
            id
            testroomName
            lessonVersion {
                id
                slides {
                    id
                    sort
                    data
                }
            }
            class {
                name
                schoolYear
                studentsCount
                students {
                    id
                    familyName
                    givenName
                    studentNumber
                }
            }
        }
    }
`;

export interface GetClassroomResultsResponse {
    results: ({
        student: {
            id: string;
        };
        slide: {
            id: string;
        };
    } & Result)[];
}

export interface GetClassroomResultsVariables {
    where: { testroom: { id: { equals: string } } };
}

export const GET_CLASSROOM_RESULTS = gql`
    query TestroomResults($where: ResultWhereInput!) {
        results(where: $where) {
            id
            message
            data
            student {
                id
            }
            startTime
            endTime
            componentId
            correct
            grading
            gameType
            slide {
                id
            }
        }
    }
`;

export interface GetHomeworkVariables {
    where: { id: string };
}

export interface GetHomeworkResponse {
    homework: {
        id: string;
        homeworkName?: string;
        lessonVersion: {
            id: string;
            slides: {
                id: string;
                sort: number;
                data: string;
            }[];
        };
        class: {
            name: string;
            schoolYear: string;
            studentsCount: number;
            students: {
                id: string;
                familyName: string;
                givenName: string;
                studentNumber: string;
            }[];
        }[];
    };
}

export const GET_HOMEWORK = gql`
    query Homework($where: HomeworkWhereUniqueInput!) {
        homework(where: $where) {
            id
            homeworkName
            lessonVersion {
                id
                slides {
                    id
                    sort
                    data
                }
            }
            class {
                name
                schoolYear
                studentsCount
                students {
                    id
                    familyName
                    givenName
                    studentNumber
                }
            }
        }
    }
`;

export interface GetHomeworkResultsResponse {
    homeworkResults: ({
        student: {
            id: string;
        };
        slide: {
            id: string;
        };
    } & Result)[];
}

export interface GetHomeworkResultsVariables {
    where: { homework: { id: { equals: string } } };
}

export const GET_HOMEWORK_RESULTS = gql`
    query HomeworkResults($where: HomeworkResultWhereInput!) {
        homeworkResults(where: $where) {
            id
            message
            data
            student {
                id
            }
            startTime
            endTime
            componentId
            correct
            grading
            gameType
            slide {
                id
            }
        }
    }
`;

export interface GetResultFilesResponse {
    resultFiles: {
        id: string;
        file: {
            url: string;
        };
    }[];
}

export const GET_RESULT_FILES = gql`
    query ResultFiles($where: ResultFileWhereInput!) {
        resultFiles(where: $where) {
            file {
                url
            }
            id
        }
    }
`;
